import { Component, HostBinding, Input, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { NodeTypeEnum } from '../../../../services/eleview/types/model';
import { Node } from '../../../../services/eleview/types/node';
import { EditLabelService } from '../edit-label.service';

@Component({
	selector: 'common-node',
	templateUrl: './node.component.html',
	styleUrls: ['./node.component.scss']
})
export class NodeComponent implements OnInit {
	readonly nodeTypeCondition = NodeTypeEnum.NodeCondition;
	readonly nodeTypeAnd = NodeTypeEnum.NodeAnd;
	readonly nodeTypeOr = NodeTypeEnum.NodeOr;
	readonly nodeTypeUnknow = NodeTypeEnum.unknow;
	readonly nodeTypePlain = NodeTypeEnum.NodePlain;
	@Input() data: Node;
	@HostBinding('class.node') hostClass = true;
	@ViewChild('nodeMain', { static: true })
	nodeMain: ElementRef;
	constructor(private lblSvr: EditLabelService, private ref: ElementRef) {}
	ngOnInit() {}
	svgHeight(): number {
		return this.data.flatHeight() * 50;
	}
	nodeDragover(event: DragEvent) {
		// å¤æ­å¦ææ¯èç¹
		if (this.data.NodeType === this.nodeTypeAnd || this.data.NodeType === this.nodeTypeOr) {
			event.preventDefault();
			const rect = (this.ref.nativeElement as Element).getBoundingClientRect();
			const offsetY = event.pageY - rect.top;
			const clientHeight = rect.height;
			if (this.lblSvr.dragOverNode !== this.data && this.lblSvr.prevNodeEle) {
				const ref = this.lblSvr.prevNodeEle.nativeElement as HTMLElement;
				ref.style.borderTop = '4px solid transparent';
				ref.style.borderBottom = '4px solid transparent';
				ref.style.backgroundColor = null;
			}
			// Handle drag area
			const percentageY = offsetY / clientHeight;
			if (percentageY < 0.5) {
				(this.nodeMain.nativeElement as HTMLElement).style.borderTop = '4px solid #67c204';
				(this.nodeMain.nativeElement as HTMLElement).style.borderBottom = '4px solid transparent';
				this.lblSvr.dragOverArea = 'above';
			} else if (percentageY >= 0.5) {
				(this.nodeMain.nativeElement as HTMLElement).style.borderTop = '4px solid transparent';
				(this.nodeMain.nativeElement as HTMLElement).style.borderBottom = '4px solid #67c204';
				this.lblSvr.dragOverArea = 'below';
			}
			this.lblSvr.dragOverNode = this.data;
			this.lblSvr.prevNodeEle = this.nodeMain;
		}
		event.stopPropagation();
	}
	// ææå¨çnodeæ¾å°èç¹ä¸è¾¹
	dropTop(event: DragEvent) {
		if (this.data.parent) {
			this.data.addTopSibling(this.lblSvr.buildDragedNode());
			if (this.lblSvr.dragData.Type === 'node') {
				(this.lblSvr.dragData.Data as Node).remove();
			}
		} else {
			this.data.Children[0].addTopSibling(this.lblSvr.buildDragedNode());
			if (this.lblSvr.dragData.Type === 'node') {
				(this.lblSvr.dragData.Data as Node).remove();
			}
		}
	}
	// ææå¨çnodeæ¾å°èç¹ä¸è¾¹
	dropBottom(event: DragEvent) {
		this.data.addBottomSibling(this.lblSvr.buildDragedNode());
		if (this.lblSvr.dragData.Type === 'node') {
			(this.lblSvr.dragData.Data as Node).remove();
		}
	}
	nodeDrop(event: DragEvent) {
		if (this.data.NodeType === this.nodeTypeAnd || this.data.NodeType === this.nodeTypeOr) {
			switch (this.lblSvr.dragOverArea) {
				case 'above':
					this.dropTop(event);
					break;
				case 'below':
					this.dropBottom(event);
					break;
			}
			this.lblSvr.onNodeChange.emit();
			this.lblSvr.dragOverNode = null;
			if (this.lblSvr.prevNodeEle) {
				const ref = this.lblSvr.prevNodeEle.nativeElement as HTMLElement;
				ref.style.borderTop = '4px solid transparent';
				ref.style.borderBottom = '4px solid transparent';
				ref.style.backgroundColor = null;
			}
		}
		event.stopPropagation();
	}
	drop(event: DragEvent) {
		if (this.data.NodeType === this.nodeTypeUnknow) {
			this.data.assign(this.lblSvr.buildDragedNode());
			this.lblSvr.onNodeChange.emit();
		}
	}
	logicClick() {
		if (this.data.NodeType === NodeTypeEnum.NodeAnd) {
			this.data.NodeType = NodeTypeEnum.NodeOr;
		} else {
			this.data.NodeType = NodeTypeEnum.NodeAnd;
		}
		this.lblSvr.onNodeChange.emit();
	}
}
